export function normalizeDeletedGroupIds(value) {
  const list = Array.isArray(value) ? value : [];
  return new Set(list.map((id) => String(id || "").trim()).filter(Boolean));
}

export function withoutDeletedGroups(groups, deletedIds) {
  const blocked = deletedIds instanceof Set
    ? deletedIds
    : normalizeDeletedGroupIds(deletedIds);
  return (Array.isArray(groups) ? groups : []).filter(
    (group) => !blocked.has(String(group?.id || "").trim())
  );
}
